import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

// Async thunk for checking readability
export const checkReadability = createAsyncThunk(
    'textReadability/checkReadability',
    async ({ text, filters }, { rejectWithValue }) => {
        try {
            const response = await apiCall('/check-readability', 'POST', { text, filters });
            // Check if the response contains an error
            if (response.error) {
                return rejectWithValue(response.message);
            }
            return response;
        } catch (error) {
            return rejectWithValue('Error analyzing readability');
        }
    }
);

const ReadabilitySlice = createSlice({
    name: 'readability',
    initialState: {
        fleschKincaid: null, // Flesch-Kincaid readability score
        longSentences: [], // Array of long sentences
        shortSentences: [], // Array of short sentences
        loading: false, // Loading state for API requests
        error: null, // Error message for failed requests
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(checkReadability.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(checkReadability.fulfilled, (state, action) => {
                state.loading = false;

                const { readability, longSentences, shortSentences } = action.payload || {};
                state.fleschKincaid = readability?.fleschKincaid || null;
                state.longSentences = Array.isArray(longSentences) ? longSentences : [];
                state.shortSentences = Array.isArray(shortSentences) ? shortSentences : [];
            })
            .addCase(checkReadability.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'An unexpected error occurred while analyzing readability';
            });
    },
});

// Reusable selectors for state access
export const selectFleschKincaid = (state) => state.readability.fleschKincaid;
export const selectLongSentences = (state) => state.readability.longSentences;
export const selectShortSentences = (state) => state.readability.shortSentences;
export const selectLoading = (state) => state.readability.loading;
export const selectError = (state) => state.readability.error;

export default ReadabilitySlice.reducer;
